import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';
import * as Icons from 'react-feather';
import reactStringReplace from 'react-string-replace';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import DeleteTodoList from './DeleteTodoList';
import ViewTodoList from './ViewTodoList';
import { logAuditEvent } from '../../utils/auditLogger';

function TodoListModal({ show, UserAction, selectedRow, onClose, onSubmit, moduleName = 'Todo List' }) {
  const [todoData, setTodoData] = useState({
    TodoId: null,
    Title: '',
    Description: '',
    DueDate: null,
    IsScheduled: 0
  });

  useEffect(() => {
    if (show) {
      if (selectedRow) {
        setTodoData({
          TodoId: selectedRow.TodoId || null,
          Title: selectedRow.Title || '',
          Description: selectedRow.Description || '',
          DueDate: selectedRow.DueDate ? new Date(selectedRow.DueDate) : null,
          IsScheduled: Number(selectedRow.IsScheduled || 0)
        });
      } else {
        setTodoData({ TodoId: null, Title: '', Description: '', DueDate: null, IsScheduled: 0 });
      }
    }
  }, [show, selectedRow]);

  const userAction = reactStringReplace(UserAction || '', 'User', () => '');

  const handleClose = (label = 'Close') => {
    logAuditEvent(moduleName, `${UserAction || 'Action'} ${label}`, `${label} clicked`);
    onClose();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(e, todoData);
  };

  const renderBody = () => {
    if (UserAction === 'View') {
      return <ViewTodoList TodoData={selectedRow} />;
    }

    if (UserAction === 'Delete') {
      return <DeleteTodoList TodoData={selectedRow} />;
    }

    return (
      <div className="row">
        <div className="col-12 mb-3">
          <label className="form-label">Title <span style={{ color: 'red' }}>*</span></label>
          <input
            type="text"
            className="form-control"
            value={todoData.Title}
            onChange={(e) => setTodoData((prev) => ({ ...prev, Title: e.target.value }))}
            placeholder="Enter todo title"
          />
        </div>
        <div className="col-12 mb-3">
          <label className="form-label">Description</label>
          <textarea
            className="form-control"
            rows={3}
            value={todoData.Description}
            onChange={(e) => setTodoData((prev) => ({ ...prev, Description: e.target.value }))}
            placeholder="Enter description"
          />
        </div>
        <div className="col-12 mb-0">
          <label className="form-label">Due Date</label>
          <DatePicker
            selected={todoData.DueDate}
            onChange={(date) => setTodoData((prev) => ({ ...prev, DueDate: date }))}
            showTimeSelect
            timeFormat="hh:mm aa"
            timeIntervals={15}
            dateFormat="dd/MM/yyyy h:mm aa"
            className="form-control"
            placeholderText="Select due date & time"
            isClearable
          />
        </div>
      </div>
    );
  };
  const handleCancel = (label) => {
      onClose();
    }
  const renderButtons = () => {
    if (UserAction === 'View') {
      return <button className="btn btn-cancel me-2" name="View" onClick={() => handleClose('Close')}>Close</button>;
    }

    if (UserAction === 'Delete') {
      return (
        <>
          <button className="btn btn-sm btn-secondary m-1" name="Delete" onClick={() => handleClose('Delete Cancel')}>Cancel</button>
          <button className="btn btn-sm btn-danger m-1" name="Delete" onClick={handleSubmit}>Delete</button>
        </>
      );
    }

    return (
      <>
        <button className="btn btn-cancel me-2" name={UserAction} onClick={() => handleClose('Cancel')}>Cancel</button>
        <button className="btn btn-submit" name={UserAction} onClick={handleSubmit}>Submit</button>
      </>
    );
  };

  return (
    UserAction !== 'Delete' ? (
      <Modal show={show}  backdrop="static">
        <ModalHeader className="modal-header border-0 custom-modal-header">
          <ModalTitle>{userAction} Todo List</ModalTitle>
          <button type="button" className="close" aria-label="Close" onClick={() => handleCancel('Close')}>
                        <span aria-hidden="true">×</span>
                    </button>
        </ModalHeader>
        <ModalBody>{renderBody()}</ModalBody>
        <ModalFooter>{renderButtons()}</ModalFooter>
      </Modal>
    ) : (
      <Modal show={show} onHide={() => handleClose('Close')} backdrop="static">
        <ModalHeader className="alert custom-alert1 alert-danger modalheader-width">
          <ModalTitle>
            <div className="custom-alert-icon">
              <Icons.AlertOctagon className="flex-shrink-0" />
            </div>
            <div>{userAction} Todo List</div>
          </ModalTitle>
        </ModalHeader>
        <ModalBody>{renderBody()}</ModalBody>
        <ModalFooter className="modalfooter-width">{renderButtons()}</ModalFooter>
      </Modal>
    )
  );
}

export default TodoListModal;
